import { t } from 'i18next';
import { useColorMode } from '@chakra-ui/react';

const MannerSignal = ({ mannerSignalColor }: { mannerSignalColor: string }) => {
  const { colorMode } = useColorMode();

  const getSignalIcon = (color: string, isDark = false) => {
    switch (color) {
      case 'red':
        return isDark ? 'graphic.ui.blinker.red.dark' : 'graphic.ui.blinker.red.light';
      case 'yellow':
        return isDark ? 'graphic.ui.blinker.yellow.dark' : 'graphic.ui.blinker.yellow.light';
      case 'green':
        return isDark ? 'graphic.ui.blinker.green.dark' : 'graphic.ui.blinker.green.light';
      default:
        return isDark ? 'graphic.ui.blinker.yellow.dark' : 'graphic.ui.blinker.yellow.light';
    }
  };

  const signalIcon = getSignalIcon(mannerSignalColor, colorMode === 'dark');

  return (
    <div className="flex gap-[4px] text-[11px] items-center">
      <p className="leading-none text-main-light-2 dark:text-main-dark-2">
        {t('TradingUserProfilePage.mannerSignal')}
      </p>
      <img
        src={`/assets/icons/manner-signals/${signalIcon}.png`}
        alt="manner signal"
        className="w-[15px] h-[15px]"
      />
    </div>
  );
};

export default MannerSignal;
